import { AlertCircle } from 'lucide-react';

interface ErrorScreenProps {
  title: string;
  message: string;
  action?: { label: string; onClick: () => void };
}

export function ErrorScreen({ title, message, action }: ErrorScreenProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 p-6 text-center">
        <AlertCircle className="w-10 h-10 text-accent-500 mx-auto mb-3" />
        <h1 className="text-lg font-semibold text-gray-900 mb-1">{title}</h1>
        <p className="text-sm text-gray-600 mb-4">{message}</p>
        {action && (
          <button
            onClick={action.onClick}
            className="px-4 py-2 text-sm bg-accent-600 hover:bg-accent-700 text-white rounded font-medium"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
